import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "formatUrl",
	standalone: true
})
export class FormatUrlPipe implements PipeTransform {
	transform(url: string): string {
		if (!url) {
			return "";
		}
		if (url.startsWith("http://") || url.startsWith("https://")) {
			return url;
		}
		return `https://${url}`;
	}
}
